import { faCircleQuestion } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { T } from "@repo/transifex";

export const HelpCenterButton = () => {
  return (
    <button className="flex items-center gap-2" type="button">
      <FontAwesomeIcon
        icon={faCircleQuestion}
        className="text-interface-neutral-5"
      />
      <p className="text-interface-neutral-6">
        <T _str="Help Center" />
      </p>
    </button>
  );
};
